// Images
import frameworks from 'assets/images/impact/frameworks.png'
import esgInitiatives from 'assets/images/impact/esg-initiatives.png'
import portfolioManagement from 'assets/images/impact/portfolio-management.png'
import mornington from "assets/images/portfolio/mornington.png"
import wollonggong from "assets/images/portfolio/wollonggong.png"
import OrganizationStructure from "assets/images/company/STRUKTUR_ORGANISASI.jpg"
import CompanyOwnership from "assets/images/company/KEPEMILIKAN_NLB.jpg"

// Icon
import AnalyzeIcon from 'assets/icons/AnalyzeIcon'
import PlanIcon from 'assets/icons/PlanIcon'

export const impacts = [
  {
    image: frameworks,
    title: "Framework",
    description: "Lorem ipsum dolor sit amet consectetur.",
    href: "/"
  },
  {
    image: esgInitiatives,
    title: "ESG Initiatives",
    description: "Lorem ipsum dolor sit amet consectetur.",
    href: "/"
  },
  {
    image: portfolioManagement,
    title: "Portfolio Management",
    description: "Lorem ipsum dolor sit amet consectetur.",
    href: "/"
  },
]

const whyUsTopContent = [
  {
    icon: AnalyzeIcon,
    title: "Global E-sport Revenue",
    description: "The potential of this nascent industry is huge. Dominated by a young, digital and global audience, the esports industry is fueled with economic opportunities measured by sponsorships, merchandising, ticket sales, advertising and media rights."
  },
  {
    icon: PlanIcon,
    title: "SEA Esports Market Outlook",
    description: "Since 2016, Indonesia placed 2nd on the esports growing market. 2017 was when the esports market in Indonesia grew drastically. Today, Indonesia is one of the leading country for Esports in SEA Region."
  }
]

const whyUsSecondContent = [
  {
    icon: AnalyzeIcon,
    title: "+75 Million",
    description: "Indonesian are gamers"
  },
  {
    icon: PlanIcon,
    title: "60% of Indonesian",
    description: "own smartphones and 17% of them are active gamers"
  },
  {
    icon: AnalyzeIcon,
    title: "14-35 years old",
    description: "from those are active gamers"
  },
  {
    icon: PlanIcon,
    title: "60% of Indonesian",
    description: "have consumtive behavior towards their hobby"
  },
  {
    icon: AnalyzeIcon,
    title: "8 hours a day",
    description: "Millenials spend their time online"
  },
  {
    icon: PlanIcon,
    title: "6 hours a week",
    description: "Millenials spend their time playing games"
  },
  {
    icon: AnalyzeIcon,
    title: "12 hours a week",
    description: "Millenials and other age group halved their TV viewership over the past 7 years"
  }
]

export const whyUs = {
  topContent: (
    <div className='app-main-container grid grid-cols-1 sm:grid-cols-2 gap-8'>
      {whyUsTopContent.map((step, i) => {
        const Icon = step.icon
        return (
          <div key={i} className='space-y-4'>
            <div className='space-y-2 app-animation-translate-start'>
              <Icon />
              <p className='font-bold uppercase text-sm md:text-base'>{step.title}</p>
            </div>
            <p className='text-sm md:text-base app-animation-translate-start'>{step.description}</p>
          </div>
        )
      })}
    </div>
  ),
  secondContent: (
    <div className='app-main-container grid grid-cols-2 sm:grid-cols-3 gap-8'>
      {whyUsSecondContent.map((step, i) => {
        const Icon = step.icon
        return (
          <div key={i}>
            <div className='space-y-2 app-animation-translate-start'>
              <Icon />
              <p className='font-bold uppercase text-sm md:text-base'>{step.title}</p>
            </div>
            <p className='text-sm md:text-base app-animation-translate-start'>{step.description}</p>
          </div>
        )
      })}
    </div>
  ),
  ourServices: [
    {
      id: 1,
      title: 'E-Sports consulting',
      link_url: '/esports-consulting',
      image_url: 'https://images.pexels.com/photos/3165335/pexels-photo-3165335.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'
    },
    {
      id: 2,
      title: 'E-Sports event organizer',
      link_url: '/esports-eo',
      image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/sl-logo.jpeg'
    },
    {
      id: 3,
      title: 'Production house specializing in OTT content and social media content',
      link_url: '/production-house',
      image_url: 'https://images.pexels.com/photos/66134/pexels-photo-66134.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'
    },
    {
      id: 4,
      title: 'Digital marketing agency',
      link_url: '/digital-marketing',
      image_url: 'https://images.pexels.com/photos/5678243/pexels-photo-5678243.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'
    },
    {
      id: 5,
      title: 'E-Sports team',
      link_url: '/esports-team',
      image_url: 'https://assets.skor.id/crop/136x76:1228x690/x/photo/2020/10/05/1364398555.jpg'
    }
  ]
}

export const about = {
  description: (
    <>
      <p className='app-animation-translate-start'>
        Our company was established in 2017 with the goal of developing esports ecosystem in Indonesia. We first started with Supreme League Arena, becoming the first cybercafe with ultimate esports ready hardware ( 240hz refresh rate monitors and top of the line CPU & GPU ) ensuring that our customers have the competitive edge in gaming.
      </p>
      <br />
      <p className='app-animation-translate-start'>
        Today, our company has more than evolved from a small cybercafe to having a multitude of services in order to develop esports.
      </p>
      <br />
      <p className='app-animation-translate-start'>
        We are the first company to create esports programs for television in Indonesia. Trusted by a cable television for more than 25 hours worth of esports content a month. We turn gaming into an entertainment watched by millions.
      </p>
      <br />
      <p className='app-animation-translate-start'>
        As an esports event organizer we have done more than 100 events including big names from Tencent, Bytedance and trusted by internationally acclaimed companies to guide them in successfully engaging with the esports Indonesian market.
      </p>
      <br />
      <p className='app-animation-translate-start'>
        We also developed an esports team in 2018 with the name Alterego Esports and in less than a year we are considered as one of the top 3 Indonesian esports team.
      </p>
      <br />
      <p className='app-animation-translate-start'>
        In the everchanging esports industry we help our clients keep up with the trends and on ways to capitalize on the millions of millennial games, using esports as a gateway to reach this lucrative demographic.
      </p>
      <br />
      <p className='app-animation-translate-start'>
        Our mission is to promote electronic sports as the next iteration of sports. Our vision is to turn esports into the biggest form of entertainment.
      </p>
    </>
  ),
  our_role_img: [{
    original: 'https://storage.googleapis.com/nizerteklintasbumi/banner/Setup-Ecosystem_NLB.png',
    thumbnail: 'https://storage.googleapis.com/nizerteklintasbumi/banner/Setup-Ecosystem_NLB.png'
  }]
}

export const structure = {
  organization_structure_img: [{
    original: OrganizationStructure,
    thumbnail: OrganizationStructure
  }]
}

export const company_ownership = {
  company_ownership_img: [{
    original: CompanyOwnership,
    thumbnail: CompanyOwnership
  }]
}

export const generalBrandsLogo = [
  {
    id: 1,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/bardi-logo.png'
  },
  {
    id: 2,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/blackshark-logo.webp'
  },
  {
    id: 3,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/boncabe-logo.png'
  },
  {
    id: 4,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/bri-logo.webp'
  },
  {
    id: 5,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/gojek-logo.png'
  },
  {
    id: 6,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/line-logo.png'
  },
  {
    id: 7,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/mandiri-logo.webp'
  },
  {
    id: 8,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/realme-logo.webp'
  },
  {
    id: 9,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/redbull-logo.png'
  },
  {
    id: 10,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/samsung-logo.svg'
  },
  {
    id: 11,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/ticketcom-logo.png'
  }
]

export const gamingPeripheralsLogo = [
  {
    id: 1,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/gaming-peripherals/amd-logo.png'
  },
  {
    id: 2,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/gaming-peripherals/aoc-logo.png'
  },
  {
    id: 3,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/gaming-peripherals/asus-logo.png'
  },
  {
    id: 4,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/gaming-peripherals/benq-logo.png'
  },
  {
    id: 5,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/gaming-peripherals/brazen-logo.webp'
  },
  {
    id: 6,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/gaming-peripherals/dxracer-logo.png'
  },
  {
    id: 7,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/gaming-peripherals/legion-logo.webp'
  },
  {
    id: 8,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/gaming-peripherals/logitech-logo.png'
  },
  {
    id: 9,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/gaming-peripherals/predator-logo.png'
  },
  {
    id: 10,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/gaming-peripherals/razer-logo.png'
  },
  {
    id: 11,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/gaming-peripherals/sandisk-logo.png'
  },
  {
    id: 12,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/gaming-peripherals/steelseries-logo.png'
  }
]

export const gamePublishersLogo = [
  {
    id: 1,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/game-publishers/gamevil-logo.jpeg'
  },
  {
    id: 2,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/game-publishers/garena-logo.png'
  },
  {
    id: 3,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/game-publishers/igg-logo.png'
  },
  {
    id: 4,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/game-publishers/linepod-logo.png'
  },
  {
    id: 5,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/game-publishers/megaxus-logo.png'
  },
  {
    id: 6,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/game-publishers/mihoyo-logo.svg'
  },
  {
    id: 7,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/game-publishers/moonton-logo.png'
  },
  {
    id: 8,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/game-publishers/riot-logo.png'
  },
  {
    id: 9,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/game-publishers/supercell-logo.png'
  },
  {
    id: 10,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/game-publishers/tencent-logo.webp'
  },
  {
    id: 11,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/game-publishers/vng-logo.png'
  }
]

export const ottContentBrand = [
  {
    id: 1,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/ott-content/firstmedia-logo.png'
  },
  {
    id: 2,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/ott-content/maxstream-logo.png'
  },
  {
    id: 3,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/ott-content/nimotv-logo.png'
  },
  {
    id: 4,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/ott-content/snackvideo-logo.png'
  },
  {
    id: 5,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/ott-content/useetv-logo.png'
  },
  {
    id: 6,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/ott-content/vidio-logo.png'
  }
]

export const internetProvidersBrand = [
  {
    id: 1,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/internet-providers/axis-logo.png'
  },
  {
    id: 2,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/internet-providers/indihome-logo.png'
  },
  {
    id: 3,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/internet-providers/myrepublic-logo.webp'
  },
  {
    id: 4,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/internet-providers/telkomsel-logo.png'
  }
]

export const phClientsLogo = [
  {
    id: 1,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/ott-content/firstmedia-logo.png'
  },
  {
    id: 2,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/ott-content/vidio-logo.png'
  },
  {
    id: 3,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/ott-content/maxstream-logo.png'
  },
  {
    id: 4,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/game-publishers/tencent-logo.webp'
  },
  {
    id: 5,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/game-publishers/supercell-logo.png'
  },
  {
    id: 6,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/ott-content/nimotv-logo.png'
  },
  {
    id: 7,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/internet-providers/telkomsel-logo.png'
  },
  {
    id: 8,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/redbull-logo.png'
  }
]

export const phVideoBanner = [
  {
    id: 1,
    title: 'Love in Game',
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/banner/love-in-game-banner.png',
    link_url: 'https://maxstream.tv/movies/0_xp5n50sz'
  }
]

export const phYoutubeVideoLinks = [
  {
    id: 1,
    title: 'PUBG Mobile Jawara Community',
    video_url: 'https://www.youtube.com/embed/iM--q-HAIUI?si=lIrzxVxp2F229AE_'
  },
  {
    id: 2,
    title: 'AOC Valentine Campaign',
    video_url: 'https://www.youtube.com/embed/ZT2XhYtwrYs?si=P_8tWcb332nFepAE'
  },
  {
    id: 3,
    title: 'AGON by AOC Campaign',
    video_url: 'https://www.youtube.com/embed/V_Nrj3FSKnw?si=WjzvnV5_BpVfm8RA'
  }
]

export const phGdriveVideoLinks = [
  {
    id: 1,
    title: 'E-Sports Time',
    video_url: 'https://drive.google.com/file/d/1rgdpg_yzKCPxw98SFB5Yk4fEJ-XkERQG/preview'
  },
  {
    id: 2,
    title: 'Mabar Yuk!',
    video_url: 'https://drive.google.com/file/d/1c__-g-W5yImfNGURE3Eaaqu162yFQ9hh/preview'
  },
  {
    id: 3,
    title: 'Forgotten Path',
    video_url: 'https://drive.google.com/file/d/1OjPGg0Vd5AZW3WE6-ORaHOUDoAwbWP9X/preview'
  }
]


export const phStudioImages = [
  {
    original: 'https://images.pexels.com/photos/668296/pexels-photo-668296.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    thumbnail: 'https://images.pexels.com/photos/668296/pexels-photo-668296.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'
  },
  {
    original: 'https://images.pexels.com/photos/66134/pexels-photo-66134.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    thumbnail: 'https://images.pexels.com/photos/66134/pexels-photo-66134.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'
  },
  {
    original: 'https://images.pexels.com/photos/2228831/pexels-photo-2228831.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    thumbnail: 'https://images.pexels.com/photos/2228831/pexels-photo-2228831.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'
  }
]

export const phStudio2Images = [
  {
    original: 'https://images.pexels.com/photos/668296/pexels-photo-668296.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    thumbnail: 'https://images.pexels.com/photos/668296/pexels-photo-668296.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'
  },
  {
    original: 'https://images.pexels.com/photos/66134/pexels-photo-66134.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    thumbnail: 'https://images.pexels.com/photos/66134/pexels-photo-66134.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'
  },
  {
    original: 'https://images.pexels.com/photos/2228831/pexels-photo-2228831.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    thumbnail: 'https://images.pexels.com/photos/2228831/pexels-photo-2228831.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'
  }
]

export const phDigitalAssetImages = [
  {
    original: 'https://images.pexels.com/photos/668296/pexels-photo-668296.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    thumbnail: 'https://images.pexels.com/photos/668296/pexels-photo-668296.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'
  },
  {
    original: 'https://images.pexels.com/photos/66134/pexels-photo-66134.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    thumbnail: 'https://images.pexels.com/photos/66134/pexels-photo-66134.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'
  },
  {
    original: 'https://images.pexels.com/photos/2228831/pexels-photo-2228831.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    thumbnail: 'https://images.pexels.com/photos/2228831/pexels-photo-2228831.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'
  }
]

export const publishingPrClients = [
  {
    id: 1,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/ott-content/firstmedia-logo.png'
  },
  {
    id: 2,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/ott-content/vidio-logo.png'
  },
  {
    id: 3,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/ott-content/maxstream-logo.png'
  },
  {
    id: 4,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/game-publishers/tencent-logo.webp'
  },
  {
    id: 5,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/game-publishers/supercell-logo.png'
  },
  {
    id: 6,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/ott-content/nimotv-logo.png'
  },
  {
    id: 7,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/internet-providers/telkomsel-logo.png'
  },
  {
    id: 8,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/redbull-logo.png'
  }
]

export const technoMediaPartnerLogo = [
  {
    id: 1,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/carisinyal.png'
  },
  {
    id: 2,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/dormatekno.png'
  },
  {
    id: 3,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/droidlime.png'
  },
  {
    id: 4,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/duerclockingid.png'
  },
  {
    id: 5,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/gadetapa.png'
  },
  {
    id: 6,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/gadgetdiva.png'
  },
  {
    id: 7,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/gadgetsquad.png'
  },
  {
    id: 8,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/gadgettren.png'
  },
  {
    id: 9,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/gawaimikro.png'
  },
  {
    id: 10,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/gayafone.png'
  },
  {
    id: 11,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/gizmologi.png'
  },
  {
    id: 12,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/hardwareholic.png'
  },
  {
    id: 13,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/hittekno.png'
  },
  {
    id: 14,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/infokom.png'
  },
  {
    id: 15,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/inilahcom.png'
  },
  {
    id: 16,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/jagatreview.png'
  },
  {
    id: 17,
    image_url: 'https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/kincir.png'
  },
  {
    "id": 18,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/mbittekno.png"
  },
  {
    "id": 19,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/nextren.png"
  },
  {
    "id": 20,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/pricebook.png"
  },
  {
    "id": 21,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/pulsa.png"
  },
  {
    "id": 22,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/review.png"
  },
  {
    "id": 23,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/selular.png"
  },
  {
    "id": 24,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/skor.png"
  },
  {
    "id": 25,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/techbiz.png"
  },
  {
    "id": 26,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/techdaily.png"
  },
  {
    "id": 27,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/technologue.png"
  },
  {
    "id": 28,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/tekid.png"
  },
  {
    "id": 29,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/teknogav.png"
  },
  {
    "id": 30,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/telkoid.png"
  },
  {
    "id": 31,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/trenteknologi.png"
  },
  {
    "id": 32,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/yangcanggih.png"
  },
  {
    "id": 33,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/youngster.png"
  }
]

export const gamingMediaPartnerLogo = [
  {
    "id": 1,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/gaming/d.png"
  },
  {
    "id": 2,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/gaming/duniagames.png"
  },
  {
    "id": 3,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/gaming/duniaku.png"
  },
  {
    "id": 4,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/gaming/esportsid.png"
  },
  {
    "id": 5,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/gaming/esportsku.png"
  },
  {
    "id": 6,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/gaming/gamebrott.png"
  },
  {
    "id": 7,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/gaming/gamedaim.png"
  },
  {
    "id": 8,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/gaming/gamefever.png"
  },
  {
    "id": 9,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/gaming/gameholic.png"
  },
  {
    "id": 10,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/gaming/ggwpid.png"
  },
  {
    "id": 11,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/gaming/gridgames.png"
  },
  {
    "id": 12,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/gaming/gudanggaming.png"
  },
  {
    "id": 13,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/gaming/hybrid.png"
  },
  {
    "id": 14,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/gaming/indoesports.png"
  },
  {
    "id": 15,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/gaming/indogames.png"
  },
  {
    "id": 16,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/gaming/jagatplay.png"
  },
  {
    "id": 17,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/gaming/kabargames.png"
  },
  {
    "id": 18,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/gaming/kaorinusantara.png"
  },
  {
    "id": 19,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/gaming/kincir.png"
  },
  {
    "id": 20,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/gaming/kotakgame.png"
  },
  {
    "id": 21,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/gaming/mastergame.png"
  },
  {
    "id": 22,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/gaming/onesports.png"
  },
  {
    "id": 23,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/gaming/revivaltv.png"
  },
  {
    "id": 24,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/gaming/skorid.png"
  },
  {
    "id": 25,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/gaming/skyegrid.png"
  },
  {
    "id": 26,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/gaming/yodu.png"
  }
]

export const generalMediaPartnerLogo = [
  {
    "id": 1,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/general/akuratco.png"
  },
  {
    "id": 2,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/general/alix.png"
  },
  {
    "id": 3,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/general/antv.svg.png"
  },
  {
    "id": 4,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/general/beritasatu.png"
  },
  {
    "id": 5,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/general/bisnisindonesia.png"
  },
  {
    "id": 6,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/general/canggihid.png"
  },
  {
    "id": 7,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/general/cnn.svg.png"
  },
  {
    "id": 8,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/general/dailysocialid.png"
  },
  {
    "id": 9,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/general/detikcom.png"
  },
  {
    "id": 10,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/general/jawapos.png"
  },
  {
    "id": 11,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/general/jpnn.png"
  },
  {
    "id": 12,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/general/kapanlagi.svg.png"
  },
  {
    "id": 13,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/general/kompas.png"
  },
  {
    "id": 14,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/general/kompascom.png"
  },
  {
    "id": 15,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/general/kompastekno.png"
  },
  {
    "id": 16,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/general/kumparan.png"
  },
  {
    "id": 17,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/general/liputan6.svg.png"
  },
  {
    "id": 18,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/general/marketeers.png"
  },
  {
    "id": 19,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/general/merahputih.png"
  },
  {
    "id": 20,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/general/merdekacom.png"
  },
  {
    "id": 21,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/general/okezone.png"
  },
  {
    "id": 22,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/general/rakyatmerdeka.png"
  },
  {
    "id": 23,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/general/republika.png"
  },
  {
    "id": 24,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/general/sindonews.png"
  },
  {
    "id": 25,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/general/suaracom.png"
  },
  {
    "id": 26,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/general/tagarid.png"
  },
  {
    "id": 27,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/general/tempo.png"
  },
  {
    "id": 28,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/general/tvone.png"
  },
  {
    "id": 29,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/general/uzone.png"
  },
  {
    "id": 30,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/general/viva.png"
  },
  {
    "id": 31,
    "image_url": "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/general/wartaekonomi.png"
  }
]

export const promotionalImages = [
  {
    original: 'https://images.pexels.com/photos/668296/pexels-photo-668296.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    thumbnail: 'https://images.pexels.com/photos/668296/pexels-photo-668296.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'
  },
  {
    original: 'https://images.pexels.com/photos/66134/pexels-photo-66134.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    thumbnail: 'https://images.pexels.com/photos/66134/pexels-photo-66134.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'
  },
  {
    original: 'https://images.pexels.com/photos/2228831/pexels-photo-2228831.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    thumbnail: 'https://images.pexels.com/photos/2228831/pexels-photo-2228831.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'
  }
]

export const marketingCatImages = [
  {
    original: 'https://images.pexels.com/photos/668296/pexels-photo-668296.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    thumbnail: 'https://images.pexels.com/photos/668296/pexels-photo-668296.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'
  },
  {
    original: 'https://images.pexels.com/photos/66134/pexels-photo-66134.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    thumbnail: 'https://images.pexels.com/photos/66134/pexels-photo-66134.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'
  },
  {
    original: 'https://images.pexels.com/photos/2228831/pexels-photo-2228831.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    thumbnail: 'https://images.pexels.com/photos/2228831/pexels-photo-2228831.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'
  }
]

export const dMarketingCatImages = [
  {
    original: 'https://images.pexels.com/photos/668296/pexels-photo-668296.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    thumbnail: 'https://images.pexels.com/photos/668296/pexels-photo-668296.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'
  },
  {
    original: 'https://images.pexels.com/photos/66134/pexels-photo-66134.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    thumbnail: 'https://images.pexels.com/photos/66134/pexels-photo-66134.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'
  },
  {
    original: 'https://images.pexels.com/photos/2228831/pexels-photo-2228831.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    thumbnail: 'https://images.pexels.com/photos/2228831/pexels-photo-2228831.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'
  }
]

export const aeImages = [
  {
    original: 'https://cdn.vcgamers.com/news/wp-content/uploads/2023/02/Logo-Alterego-1.jpg',
    thumbnail: 'https://cdn.vcgamers.com/news/wp-content/uploads/2023/02/Logo-Alterego-1.jpg',
    description: 'Alter Ego 1'
  },
  {
    original: 'https://awsimages.detik.net.id/community/media/visual/2022/08/03/ini-dia-roster-baru-alter-ego-esports-di-mpl-id-s10_169.png?w=1200',
    thumbnail: 'https://awsimages.detik.net.id/community/media/visual/2022/08/03/ini-dia-roster-baru-alter-ego-esports-di-mpl-id-s10_169.png?w=1200',
    description: 'Alter Ego 2'
  },
  {
    original: 'https://d1tgyzt3mf06m9.cloudfront.net/v3-staging/2023/08/230827-PMSL-SEA-Fall-2023-Alter-Ego-Juara.png',
    thumbnail: 'https://d1tgyzt3mf06m9.cloudfront.net/v3-staging/2023/08/230827-PMSL-SEA-Fall-2023-Alter-Ego-Juara.png',
    description: 'Alter Ego 3'
  }
]

export const portfolio = [
  {
    id: 1,
    image: mornington,
    name: "Mornington peninsula villas",
    description: (
      <>
        <p className='app-animation-translate-start'>
          Lorem ipsum dolor sit amet consectetur.Id magna convallis diam condimentum felis convallis.Sed faucibus sagittis a sed commodo fermentum massa.Mauris venenatis lacus at semper.Purus tortor massa ac ultrices gravida in.Viverra ipsum in viverra nisl dignissim gravida vitae.Scelerisque sagittis sem dignissim eleifend ac.
        </p>
        <br />
        <p className='app-animation-translate-start'>
          Lorem ipsum dolor sit amet consectetur.Id magna convallis diam condimentum felis convallis.Sed faucibus sagittis a sed commodo fermentum massa.Mauris venenatis lacus at semper.Purus tortor massa ac ultrices gravida in.Viverra ipsum in viverra nisl dignissim gravida vitae.Scelerisque sagittis sem dignissim eleifend ac.
        </p>
        <br />
        <p className='app-animation-translate-start'>
          Lorem ipsum dolor sit amet consectetur.Id magna convallis diam condimentum felis convallis.Sed faucibus sagittis a sed commodo fermentum massa.Mauris venenatis lacus at semper.Purus tortor massa ac ultrices gravida in.Viverra ipsum in viverra nisl dignissim gravida vitae.Scelerisque sagittis sem dignissim eleifend ac.
        </p>
        <br />
        <p className='app-animation-translate-start'>
          Lorem ipsum dolor sit amet consectetur.Id magna convallis diam condimentum felis convallis.Sed faucibus sagittis a sed commodo fermentum massa.Mauris venenatis lacus at semper.Purus tortor massa ac ultrices gravida in.Viverra ipsum in viverra nisl dignissim gravida vitae.Scelerisque sagittis sem dignissim eleifend ac.
        </p>
      </>
    ),
    section1Photos: [
      mornington,
      mornington
    ],
    section2Photos: [
      mornington,
      mornington
    ],
    tagline: "Modern living reimagined. Bringing the balance for luxury and minimalist."
  },
  {
    id: 2,
    image: wollonggong,
    name: "Wollonggong private residence",
    description: (
      <>
        <p className='app-animation-translate-start'>
          Lorem ipsum dolor sit amet consectetur.Id magna convallis diam condimentum felis convallis.Sed faucibus sagittis a sed commodo fermentum massa.Mauris venenatis lacus at semper.Purus tortor massa ac ultrices gravida in.Viverra ipsum in viverra nisl dignissim gravida vitae.Scelerisque sagittis sem dignissim eleifend ac.
        </p>
        <br />
        <p className='app-animation-translate-start'>
          Lorem ipsum dolor sit amet consectetur.Id magna convallis diam condimentum felis convallis.Sed faucibus sagittis a sed commodo fermentum massa.Mauris venenatis lacus at semper.Purus tortor massa ac ultrices gravida in.Viverra ipsum in viverra nisl dignissim gravida vitae.Scelerisque sagittis sem dignissim eleifend ac.
        </p>
        <br />
        <p className='app-animation-translate-start'>
          Lorem ipsum dolor sit amet consectetur.Id magna convallis diam condimentum felis convallis.Sed faucibus sagittis a sed commodo fermentum massa.Mauris venenatis lacus at semper.Purus tortor massa ac ultrices gravida in.Viverra ipsum in viverra nisl dignissim gravida vitae.Scelerisque sagittis sem dignissim eleifend ac.
        </p>
        <br />
        <p className='app-animation-translate-start'>
          Lorem ipsum dolor sit amet consectetur.Id magna convallis diam condimentum felis convallis.Sed faucibus sagittis a sed commodo fermentum massa.Mauris venenatis lacus at semper.Purus tortor massa ac ultrices gravida in.Viverra ipsum in viverra nisl dignissim gravida vitae.Scelerisque sagittis sem dignissim eleifend ac.
        </p>
      </>
    ),
    section1Photos: [
      wollonggong,
      wollonggong
    ],
    section2Photos: [
      wollonggong,
      wollonggong
    ],
    tagline: "Modern living reimagined. Bringing the balance for luxury and minimalist."
  },
  {
    id: 3,
    image: mornington,
    name: "Mornington peninsula villas",
    description: (
      <>
        <p className='app-animation-translate-start'>
          Lorem ipsum dolor sit amet consectetur.Id magna convallis diam condimentum felis convallis.Sed faucibus sagittis a sed commodo fermentum massa.Mauris venenatis lacus at semper.Purus tortor massa ac ultrices gravida in.Viverra ipsum in viverra nisl dignissim gravida vitae.Scelerisque sagittis sem dignissim eleifend ac.
        </p>
        <br />
        <p className='app-animation-translate-start'>
          Lorem ipsum dolor sit amet consectetur.Id magna convallis diam condimentum felis convallis.Sed faucibus sagittis a sed commodo fermentum massa.Mauris venenatis lacus at semper.Purus tortor massa ac ultrices gravida in.Viverra ipsum in viverra nisl dignissim gravida vitae.Scelerisque sagittis sem dignissim eleifend ac.
        </p>
        <br />
        <p className='app-animation-translate-start'>
          Lorem ipsum dolor sit amet consectetur.Id magna convallis diam condimentum felis convallis.Sed faucibus sagittis a sed commodo fermentum massa.Mauris venenatis lacus at semper.Purus tortor massa ac ultrices gravida in.Viverra ipsum in viverra nisl dignissim gravida vitae.Scelerisque sagittis sem dignissim eleifend ac.
        </p>
        <br />
        <p className='app-animation-translate-start'>
          Lorem ipsum dolor sit amet consectetur.Id magna convallis diam condimentum felis convallis.Sed faucibus sagittis a sed commodo fermentum massa.Mauris venenatis lacus at semper.Purus tortor massa ac ultrices gravida in.Viverra ipsum in viverra nisl dignissim gravida vitae.Scelerisque sagittis sem dignissim eleifend ac.
        </p>
      </>
    ),
    section1Photos: [
      mornington,
      mornington
    ],
    section2Photos: [
      mornington,
      mornington
    ],
    tagline: "Modern living reimagined. Bringing the balance for luxury and minimalist."
  },
  {
    id: 4,
    image: wollonggong,
    name: "Wollonggong private residence",
    description: (
      <>
        <p className='app-animation-translate-start'>
          Lorem ipsum dolor sit amet consectetur.Id magna convallis diam condimentum felis convallis.Sed faucibus sagittis a sed commodo fermentum massa.Mauris venenatis lacus at semper.Purus tortor massa ac ultrices gravida in.Viverra ipsum in viverra nisl dignissim gravida vitae.Scelerisque sagittis sem dignissim eleifend ac.
        </p>
        <br />
        <p className='app-animation-translate-start'>
          Lorem ipsum dolor sit amet consectetur.Id magna convallis diam condimentum felis convallis.Sed faucibus sagittis a sed commodo fermentum massa.Mauris venenatis lacus at semper.Purus tortor massa ac ultrices gravida in.Viverra ipsum in viverra nisl dignissim gravida vitae.Scelerisque sagittis sem dignissim eleifend ac.
        </p>
        <br />
        <p className='app-animation-translate-start'>
          Lorem ipsum dolor sit amet consectetur.Id magna convallis diam condimentum felis convallis.Sed faucibus sagittis a sed commodo fermentum massa.Mauris venenatis lacus at semper.Purus tortor massa ac ultrices gravida in.Viverra ipsum in viverra nisl dignissim gravida vitae.Scelerisque sagittis sem dignissim eleifend ac.
        </p>
        <br />
        <p className='app-animation-translate-start'>
          Lorem ipsum dolor sit amet consectetur.Id magna convallis diam condimentum felis convallis.Sed faucibus sagittis a sed commodo fermentum massa.Mauris venenatis lacus at semper.Purus tortor massa ac ultrices gravida in.Viverra ipsum in viverra nisl dignissim gravida vitae.Scelerisque sagittis sem dignissim eleifend ac.
        </p>
      </>
    ),
    section1Photos: [
      wollonggong,
      wollonggong
    ],
    section2Photos: [
      wollonggong,
      wollonggong
    ],
    tagline: "Modern living reimagined. Bringing the balance for luxury and minimalist."
  },
]

export const posts = [
  {
    image: mornington,
    title: "Mornington peninsula villas",
    description: "Lorem ipsum dolor sit amet consectetur. Id magna convallis diam condimentum felis convallis. "
  },
  {
    image: mornington,
    title: "Mornington peninsula villas",
    description: "Lorem ipsum dolor sit amet consectetur. Id magna convallis diam condimentum felis convallis. "
  },
  {
    image: mornington,
    title: "Mornington peninsula villas",
    description: "Lorem ipsum dolor sit amet consectetur. Id magna convallis diam condimentum felis convallis. "
  },
]


